import { CriterionDetailsDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionDetailsDialog';
import CriterionDetailsDialog from "@Criteria/Hierarchies/Components/CriterionDetailsDialog.vue";
import { SavePanelistCriterionVotesCommandV1 } from "@Evaluation/CriteriaSurveys/Domain/commands-core";
import CriteriaSurveyCommands from '@Evaluation/CriteriaSurveys/Domain/commands-vue-component';
import CriteriaSurveysQueries from '@Evaluation/CriteriaSurveys/Domain/queries-vue-component';
import { PanelistSurveyCriterionConsistencyAnalysisReadModel, PanelistSurveyCriterionPageReadModel, PanelistSurveyQuestionReadModel } from '@Evaluation/CriteriaSurveys/Domain/readmodels';
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { isNullOrWhitespace } from "@common/Common";
import $ from 'jquery';
import Component, { mixins } from 'vue-class-component';
import { Route } from 'vue-router';


@Component({
    components: {
        CriterionDetailsDialog
    },
    watch: {
        IsSaved: 'onIsSavedChanged'
    }
})
export default class PanelistSurveyCriterionPage extends mixins(CriteriaSurveysQueries, CriteriaSurveyCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get surveyId(): number { return Number.parseInt(this.$route.params.surveyId); }
    get projectUserId(): number { return Number.parseInt(this.$route.params.projectUserId); }
    get criterionId(): number { return Number.parseInt(this.$route.params.criterionId); }

    initialized: boolean = false;
    searchPhrase: string | null = null;
    questionsFilter: string | null = null;
    IsSaved: boolean | null = true;
    AutoSaveHandle: NodeJS.Timeout = null;
    criterionDetailsDialog: CriterionDetailsDialogViewModel = new CriterionDetailsDialogViewModel();

    rm: PanelistSurveyCriterionPageReadModel | null = null;
    get Progress(): number { return Math.round(100 * this.AnsweredQuestionsCount / this.QuestionsCount); }
    get ProgressStr(): string { return `${this.AnsweredQuestionsCount} / ${this.QuestionsCount}`; }

    get QuestionsCount(): number { return this.rm.Questions.length; }
    get AnsweredQuestionsCount(): number { return this.rm.Questions.filter(a => a.Value != null).length; }
    get NotAnsweredQuestionsCount(): number { return this.QuestionsCount - this.AnsweredQuestionsCount; }
    get CommentedQuestionsCount(): number { return this.rm.Questions.filter(a => !isNullOrWhitespace(a.Comment)).length; }
    get NotCommentedQuestionsCount(): number { return this.QuestionsCount - this.CommentedQuestionsCount; }

    get QuestionsView(): PanelistSurveyQuestionReadModel[]     
    {
        let view = [...this.rm.Questions];

        if (!isNullOrWhitespace(this.searchPhrase))
        {
            const phrase = this.searchPhrase.toLowerCase();
            view = view.filter(q => q.Path1.toLowerCase().indexOf(phrase) >= 0 || q.Path2.toLowerCase().indexOf(phrase) >= 0);
        }

        if (this.questionsFilter === "Answered")
        {
            view = view.filter(a => a.Value != null);
        }
        else if (this.questionsFilter === "Not answered")
        {
            view = view.filter(a => a.Value == null);
        }
        else if (this.questionsFilter === "Commented")
        {
            view = view.filter(a => !isNullOrWhitespace(a.Comment));
        }
        else if (this.questionsFilter === "Not commented")
        {
            view = view.filter(a => isNullOrWhitespace(a.Comment));
        }

        return view;
    }

    get MostInconsistent(): PanelistSurveyQuestionReadModel[] 
    {
        if (this.rm.ConsistencyAnalysis == null) return null;
        return this.rm.Questions.filter(a => this.rm.ConsistencyAnalysis.MostInconsistentIds.includes(a.Id));
    }

    get IsConsistent(): boolean { return this.rm.ConsistencyAnalysis?.IsConsistent; }
    get IsAcceptable(): boolean { return this.rm.ConsistencyAnalysis?.IsAcceptable; }
    get IsInconsistent(): boolean { return this.rm.ConsistencyAnalysis?.IsInconsistent; }
    get InsufficientData(): boolean { return this.rm.ConsistencyAnalysis?.IsUnknown; }

    getDomId(q: PanelistSurveyQuestionReadModel) { return `q${q.Id}`.split('.').join(''); }//remove dots from domId 

    getScaleLabel(value: number | null): string 
    {
        if (value == null) return "";

        value = value < 1.0 ? Math.round((1 / value) * 100) / 100 : value;

        const scaleMapping: { [key: number]: string } = {
            2.0: "Weakly",
            3.0: "Moderately",
            4.0: "Moderately +",
            5.0: "Strongly",
            6.0: "Strongly +",
            7.0: "Very Strongly",
            8.0: "Very Strongly +",
            9.0: "Extremely"
        };

        return scaleMapping[value as keyof typeof scaleMapping] || "";
    }

    //@Watch('IsSaved')
    onIsSavedChanged(val: boolean, oldVal: boolean) 
    {
        if (val === false)
        {
            if (this.AutoSaveHandle == null)
            {
                this.AutoSaveHandle = setInterval(() =>
                {
                    if (this.IsSaved === false)
                    {
                        this.handleSavePanelistCriterionVotesCommand();
                    }

                }, 10000);
            }
        }
        else
        {
            if (this.AutoSaveHandle != null)
            {
                clearInterval(this.AutoSaveHandle);
                this.AutoSaveHandle = null;
            }
        }
    }


    showCriterionDetails(name: string, path: string, desc: string)
    {
        this.criterionDetailsDialog.show(name, path, desc);
    }

    showConsistencyAnalysisLegend()
    {
        //new ConsistencyAnalysisLegendVM().Render();
    }

    highlightQuestion(q: PanelistSurveyQuestionReadModel)
    {
        if (this.QuestionsView.indexOf(q) === -1)
        {
            this.questionsFilter = null;
        }

        const handle = setTimeout(() =>
        {
            q.Highlighted = false;
            clearTimeout(handle);
        }, 1000);

        q.Highlighted = true;

        const divTop = $(`#${this.getDomId(q)}`).offset().top;
        window.scrollTo({ top: divTop, behavior: 'smooth' });
    }

    scrollTop()
    {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }


    SetValueCommand(q: PanelistSurveyQuestionReadModel, value: number)
    {
        q.Value = value;
        this.IsSaved = false;
    }

    setComment(comment: string, q: PanelistSurveyQuestionReadModel)
    {
        if (q.Comment !== comment)
        {
            q.Comment = comment;
            this.IsSaved = false;
        }
    }

    loadConsistencyAnalysis()
    {
        this.rm.ConsistencyAnalysis = null;

        if (this.IsSaved === false)
        {
            this.handleSavePanelistCriterionVotesCommand();
        }

        this.runPanelistSurveyCriterionConsistencyAnalysisQueryV1(this.workspaceId, this.rm.CriteriaHierarchyId, this.rm.EvalModelId, this.surveyId, this.projectUserId, this.criterionId);
    }


    handleSavePanelistCriterionVotesCommand()
    {
        this.IsSaved = null;

        const votes = this.rm.Questions.map(q =>
        {
            return {
                QuestionId: q.Id,
                Comment: q.Comment,
                Value: q.Value
            };
        });

        this.invokeSavePanelistCriterionVotesCommandV1(this.workspaceId, this.rm.EvalModelId, this.surveyId, this.projectUserId, this.criterionId, votes);
    }


    mounted()
    {
        this.runPanelistSurveyCriterionPageQueryV1(this.workspaceId, this.surveyId, this.projectUserId, this.criterionId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PanelistSurveyCriterionPageReadModel")
        {
            this.rm = model as PanelistSurveyCriterionPageReadModel;

            if (this.rm.RedirectionUrl)
            {
                location.href = this.rm.RedirectionUrl;
            }
            else
            {
                this.initialized = true;
            }
        }
        else if (modelName == "PanelistSurveyCriterionConsistencyAnalysisReadModel")
        {
            this.rm.ConsistencyAnalysis = model as PanelistSurveyCriterionConsistencyAnalysisReadModel;
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (SavePanelistCriterionVotesCommandV1.matchType(cmd))
        {
            if (this.criterionId === Number.parseInt(correlationId))
            {
                if (this.IsSaved == null)
                {
                    this.IsSaved = true;
                }
            }
        }
    }


    EnsureSavedOnExit(event: BeforeUnloadEvent)
    {
        if (this.IsSaved === true)
        {
            return;
        }

        this.handleSavePanelistCriterionVotesCommand();
        event.preventDefault();
        event.returnValue = "";
    }

    beforeMount()
    {
        window.addEventListener("beforeunload", this.EnsureSavedOnExit);
    }

    beforeRouteLeave(to: Route, from: Route, next: (arg?: any) => void)
    {
        if (this.IsSaved === false)
        {
            this.handleSavePanelistCriterionVotesCommand();
        }

        next();
    }

    beforeRouteUpdate(to: Route, from: Route, next: (arg?: any) => void)
    {
        if (this.IsSaved === false)
        {
            this.handleSavePanelistCriterionVotesCommand();
        }

        next();
    }


    beforeDestroy()
    {
        window.removeEventListener("beforeunload", this.EnsureSavedOnExit);

        if (this.AutoSaveHandle != null)
        {
            clearInterval(this.AutoSaveHandle);
            this.AutoSaveHandle = null;
        }
    }
}